import $ from 'jquery'

function componentModalCenter(modalClass) {
    //画面中央を計算する関数を実行
    modalResize();

    //画面の左上からmodal-mainの横幅・高さを引き、その値を2で割ると画面中央の位置が計算できます
    $(window).resize(modalResize);

    function modalResize(){
        var w = $(window).width();
        var h = $(window).height();

        var cw = $(modalClass).outerWidth();
        var ch = $(modalClass).outerHeight();

        //取得した値をcssに追加する
        $(modalClass).css({
            "left": ((w - cw)/2) + "px",
            "top": ((h - ch)/2) + "px"
        });
    }
}

export default componentModalCenter